<script>
    /*
    	MultiMergePaginator.svelte

        This component receives an array (of Services) and determines length.
        It maintains a local currentIndex and reports this back to the host.
        Clickable icons increment and decrement the currentIndex and wrap around as needed.
        
        <<  Service 3 of 5  >>
    */

    import { onMount } from 'svelte';

    // TCARE components

    // SMUI components
    import { Icon } from '@smui/icon-button';
	import { Svg } from '@smui/common/elements';
	import { mdiArrowLeftCircle, mdiArrowRightCircle, mdiCheckBold } from '@mdi/js';
	import { mdiChevronLeftCircle, mdiChevronRightCircle } from '@mdi/js';
    
    export let services;
    export let setCurrentIndex;            // setter on host panel

    $: currentIndex = 0;

    onMount(() => {
        // console.log('');
        // console.log('MultiMergePaginator onMount: ');
        // console.log('services:');
        // console.log(services);
        // console.log('');
    })

    const decrCurrentIndex = () => {
        currentIndex--;
        if (currentIndex < 0) currentIndex = services.length - 1;           // wrap under
        setCurrentIndex(currentIndex);
    }
    
    const incrCurrentIndex = () => {
        currentIndex++;
        if (currentIndex >= services.length) currentIndex = 0;              // wrap over
        setCurrentIndex(currentIndex);
    }
    

</script>

<style>
    .multi-merge-paginator {
        user-select: none;
        /* width: 190px; */
        min-height: 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        /* border: 1px solid green; */
    }

    .multi-merge-paginator .icon {
        width: 28px;
        height: 28px;
    }

    :global(.multi-merge-paginator .icon svg) {
        width: 100%;
        height: 100%;
        fill: var(--tcare-purple);
    }

    .multi-merge-paginator .message {
        font-size: 15px;
        min-width: 120px;
        color: var(--tcare-primary);
        text-align: center;
    }

    .multi-merge-paginator .message span {
        font-weight: 800;
    }

    /*
    .multi-merge-paginator .current-id {
        margin-left: 50px;
    }
    */
    

    @media screen and (max-width: 600px) {
    }

    @media screen and (min-width: 601px) and (max-width: 1300px) {
    }

    @media screen and (min-width: 1201px) {
    }

</style>

{#if services && services.length > 0}
    <div class="multi-merge-paginator">

        <!-- prev icon -->
        <div class="icon" on:click={decrCurrentIndex}>
            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiChevronLeftCircle} /></Icon>
        </div>

        <div class="message">
            <span>Service {currentIndex+1}</span> / {services.length}
        </div>

        <!-- next icon -->
        <div class="icon" on:click={incrCurrentIndex}>
            <Icon component={Svg} viewBox="0 0 24 24" ><path d={mdiChevronRightCircle} /></Icon>
        </div>

        <!--
        <div class="current-id">
            Service ID: {services[currentIndex].id}
        </div>
        -->

    </div>
{/if}
